function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _Symbol$for;
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import UserFacingApiError from '@uppy/utils/lib/UserFacingApiError';
// eslint-disable-next-line import/no-extraneous-dependencies
import pRetry, { AbortError } from 'p-retry';
import fetchWithNetworkError from '@uppy/utils/lib/fetchWithNetworkError';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import AuthError from "./AuthError.js";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.8.2"
};
// Remove the trailing slash so we can always safely append /xyz.
function stripSlash(url) {
  return url.replace(/\/$/, '');
}
var retryCount = 10; // set to a low number, like 2 to test manual user retries
var socketActivityTimeoutMs = 5 * 60 * 1000; // set to a low number like 10000 to test this

export var authErrorStatusCode = 401;
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);
  function HttpError(_ref) {
    var _this2;
    _classCallCheck(this, HttpError);
    var statusCode = _ref.statusCode,
      message = _ref.message;
    _this2 = _callSuper(this, HttpError, [message]);
    _this2.name = 'HttpError';
    _this2.statusCode = statusCode;
    return _this2;
  }
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function handleJSONResponse(_x) {
  return _handleJSONResponse.apply(this, arguments);
}
function _handleJSONResponse() {
  _handleJSONResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(res) {
    var errMsg, errData;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!(res.status === authErrorStatusCode)) {
            _context10.next = 2;
            break;
          }
          throw new AuthError();
        case 2:
          if (!res.ok) {
            _context10.next = 4;
            break;
          }
          return _context10.abrupt("return", res.json());
        case 4:
          errMsg = "Failed request with status: ".concat(res.status, ". ").concat(res.statusText);
          _context10.prev = 5;
          _context10.next = 8;
          return res.json();
        case 8:
          errData = _context10.sent;
          if (errData.message) errMsg = "".concat(errMsg, " message: ").concat(errData.message);
          if (errData.requestId) errMsg = "".concat(errMsg, " request-Id: ").concat(errData.requestId);
          _context10.next = 16;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](5);
          throw new Error(errMsg, {
            cause: _context10.t0
          });
        case 16:
          if (!(res.status >= 400 && res.status <= 499 && errData.message)) {
            _context10.next = 18;
            break;
          }
          throw new UserFacingApiError(errData.message);
        case 18:
          throw new HttpError({
            statusCode: res.status,
            message: errMsg
          });
        case 19:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[5, 13]]);
  }));
  return _handleJSONResponse.apply(this, arguments);
}
var _companionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("companionHeaders");
var _getUrl = /*#__PURE__*/_classPrivateFieldLooseKey("getUrl");
var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");
var _awaitRemoteFileUpload = /*#__PURE__*/_classPrivateFieldLooseKey("awaitRemoteFileUpload");
_Symbol$for = Symbol.for('uppy test: getCompanionHeaders');
var RequestClient = /*#__PURE__*/function (_Symbol$for2) {
  function RequestClient(uppy, opts) {
    var _this3 = this;
    _classCallCheck(this, RequestClient);
    /**
     * This method will ensure a websocket for the specified file and returns a promise that resolves
     * when the file has finished downloading, or rejects if it fails.
     * It will retry if the websocket gets disconnected
     */
    Object.defineProperty(this, _awaitRemoteFileUpload, {
      value: _awaitRemoteFileUpload2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _companionHeaders, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
          var _file$remote, file, postBody, signal, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                file = _ref2.file, postBody = _ref2.postBody, signal = _ref2.signal;
                if (!(((_file$remote = file.remote) == null ? void 0 : _file$remote.url) == null)) {
                  _context.next = 3;
                  break;
                }
                throw new Error('Cannot connect to an undefined URL');
              case 3:
                _context.next = 5;
                return _this3.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), postBody), {
                  signal: signal
                });
              case 5:
                res = _context.sent;
                return _context.abrupt("return", res.token);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function value(_x2) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    this.uppy = uppy;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    // TODO: Remove optional chaining
    _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }
  _createClass(RequestClient, [{
    key: "setCompanionHeaders",
    value: function setCompanionHeaders(headers) {
      _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = headers;
    }
  }, {
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders];
    }
  }, {
    key: "hostname",
    get: function get() {
      var _this$uppy$getState = this.uppy.getState(),
        companion = _this$uppy$getState.companion;
      var host = this.opts.companionUrl;
      return stripSlash(companion && companion[host] ? companion[host] : host);
    }
  }, {
    key: "headers",
    value: function () {
      var _headers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(emptyBody) {
        var defaultHeaders;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (emptyBody === void 0) {
                emptyBody = false;
              }
              defaultHeaders = _objectSpread({
                Accept: 'application/json'
              }, emptyBody ? undefined : {
                // Passing those headers on requests with no data forces browsers to first make a preflight request.
                'Content-Type': 'application/json'
              });
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, defaultHeaders), _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders]));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function headers(_x3) {
        return _headers.apply(this, arguments);
      }
      return headers;
    }()
  }, {
    key: "onReceiveResponse",
    value: function onReceiveResponse(res) {
      var headers = res.headers;
      var state = this.uppy.getState();
      var companion = state.companion || {};
      var host = this.opts.companionUrl;

      // Store the self-identified domain name for the Companion instance we just hit.
      if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
        this.uppy.setState({
          companion: _objectSpread(_objectSpread({}, companion), {}, _defineProperty({}, host, headers.get('i-am')))
        });
      }
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var path, _ref3$method, method, data, skipPostResponse, signal, headers, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              path = _ref3.path, _ref3$method = _ref3.method, method = _ref3$method === void 0 ? 'GET' : _ref3$method, data = _ref3.data, skipPostResponse = _ref3.skipPostResponse, signal = _ref3.signal;
              _context3.prev = 1;
              _context3.next = 4;
              return this.headers(!data);
            case 4:
              headers = _context3.sent;
              _context3.next = 7;
              return fetchWithNetworkError(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
                method: method,
                signal: signal,
                headers: headers,
                credentials: this.opts.companionCookiesRule || 'same-origin',
                body: data ? JSON.stringify(data) : null
              });
            case 7:
              response = _context3.sent;
              if (!skipPostResponse) this.onReceiveResponse(response);
              _context3.next = 11;
              return handleJSONResponse(response);
            case 11:
              return _context3.abrupt("return", _context3.sent);
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](1);
              if (!(_context3.t0.isAuthError || _context3.t0.name === 'UserFacingApiError' || _context3.t0.name === 'AbortError')) {
                _context3.next = 18;
                break;
              }
              throw _context3.t0;
            case 18:
              throw new ErrorWithCause("Could not ".concat(method, " ").concat(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path)), {
                cause: _context3.t0
              });
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 14]]);
      }));
      function request(_x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(path, options) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // TODO: remove boolean support for options that was added for backward compatibility.
              // eslint-disable-next-line no-param-reassign
              if (typeof options === 'boolean') options = {
                skipPostResponse: options
              };
              return _context4.abrupt("return", this.request(_objectSpread(_objectSpread({}, options), {}, {
                path: path
              })));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function get(_x5, _x6) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(path, data, options) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // TODO: remove boolean support for options that was added for backward compatibility.
              // eslint-disable-next-line no-param-reassign
              if (typeof options === 'boolean') options = {
                skipPostResponse: options
              };
              return _context5.abrupt("return", this.request(_objectSpread(_objectSpread({}, options), {}, {
                path: path,
                method: 'POST',
                data: data
              })));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function post(_x7, _x8, _x9) {
        return _post.apply(this, arguments);
      }
      return post;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(path, data, options) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // TODO: remove boolean support for options that was added for backward compatibility.
              // eslint-disable-next-line no-param-reassign
              if (typeof options === 'boolean') options = {
                skipPostResponse: options
              };
              return _context6.abrupt("return", this.request(_objectSpread(_objectSpread({}, options), {}, {
                path: path,
                method: 'DELETE',
                data: data
              })));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function _delete(_x10, _x11, _x12) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * Remote uploading consists of two steps:
     * 1. #requestSocketToken which starts the download/upload in companion and returns a unique token for the upload.
     * Then companion will halt the upload until:
     * 2. #awaitRemoteFileUpload is called, which will open/ensure a websocket connection towards companion, with the
     * previously generated token provided. It returns a promise that will resolve/reject once the file has finished
     * uploading or is otherwise done (failed, canceled)
     */
  }, {
    key: "uploadRemoteFile",
    value: (function () {
      var _uploadRemoteFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(file, reqBody, options) {
        var _this4 = this;
        var _this, _ref6, signal, getQueue;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = this;
              _context9.prev = 1;
              _ref6 = options || {}, signal = _ref6.signal, getQueue = _ref6.getQueue;
              _context9.next = 5;
              return pRetry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                var _this$uppy$getFile, existingServerToken, queueRequestSocketToken, serverToken;
                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      // if we already have a serverToken, assume that we are resuming the existing server upload id
                      existingServerToken = (_this$uppy$getFile = _this4.uppy.getFile(file.id)) == null ? void 0 : _this$uppy$getFile.serverToken;
                      if (!(existingServerToken != null)) {
                        _context8.next = 4;
                        break;
                      }
                      _this4.uppy.log("Connecting to exiting websocket ".concat(existingServerToken));
                      return _context8.abrupt("return", _classPrivateFieldLooseBase(_this4, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
                        file: file,
                        queue: getQueue(),
                        signal: signal
                      }));
                    case 4:
                      queueRequestSocketToken = getQueue().wrapPromiseFunction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                        var _classPrivateFieldLoo,
                          err,
                          isRetryableHttpError,
                          _args7 = arguments;
                        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                          while (1) switch (_context7.prev = _context7.next) {
                            case 0:
                              _context7.prev = 0;
                              _context7.next = 3;
                              return (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this, _requestSocketToken))[_requestSocketToken].apply(_classPrivateFieldLoo, _args7);
                            case 3:
                              return _context7.abrupt("return", _context7.sent);
                            case 6:
                              _context7.prev = 6;
                              _context7.t0 = _context7["catch"](0);
                              if (!_context7.t0.isAuthError) {
                                _context7.next = 10;
                                break;
                              }
                              throw new AbortError(_context7.t0);
                            case 10:
                              if (!(_context7.t0.cause == null)) {
                                _context7.next = 12;
                                break;
                              }
                              throw _context7.t0;
                            case 12:
                              err = _context7.t0.cause;
                              isRetryableHttpError = function isRetryableHttpError() {
                                return [408, 409, 429, 418, 423].includes(err.statusCode) || err.statusCode >= 500 && err.statusCode <= 599 && ![501, 505].includes(err.statusCode);
                              };
                              if (!(err.name === 'HttpError' && !isRetryableHttpError())) {
                                _context7.next = 16;
                                break;
                              }
                              throw new AbortError(err);
                            case 16:
                              throw err;
                            case 17:
                            case "end":
                              return _context7.stop();
                          }
                        }, _callee7, null, [[0, 6]]);
                      })), {
                        priority: -1
                      });
                      _context8.next = 7;
                      return queueRequestSocketToken({
                        file: file,
                        postBody: reqBody,
                        signal: signal
                      }).abortOn(signal);
                    case 7:
                      serverToken = _context8.sent;
                      if (_this4.uppy.getFile(file.id)) {
                        _context8.next = 10;
                        break;
                      }
                      return _context8.abrupt("return", undefined);
                    case 10:
                      // has file since been removed?

                      _this4.uppy.setFileState(file.id, {
                        serverToken: serverToken
                      });
                      return _context8.abrupt("return", _classPrivateFieldLooseBase(_this4, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
                        file: _this4.uppy.getFile(file.id),
                        // re-fetching file because it might have changed in the meantime
                        queue: getQueue(),
                        signal: signal
                      }));
                    case 12:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              })), {
                retries: retryCount,
                signal: signal,
                onFailedAttempt: function onFailedAttempt(err) {
                  return _this4.uppy.log("Retrying upload due to: ".concat(err.message), 'warning');
                }
              });
            case 5:
              return _context9.abrupt("return", _context9.sent);
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](1);
              if (!(_context9.t0.name === 'AbortError')) {
                _context9.next = 12;
                break;
              }
              return _context9.abrupt("return", undefined);
            case 12:
              this.uppy.emit('upload-error', file, _context9.t0);
              throw _context9.t0;
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 8]]);
      }));
      function uploadRemoteFile(_x13, _x14, _x15) {
        return _uploadRemoteFile.apply(this, arguments);
      }
      return uploadRemoteFile;
    }())
  }]);
  return RequestClient;
}(_Symbol$for);
export { RequestClient as default };
function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }
  return "".concat(this.hostname, "/").concat(url);
}
function _awaitRemoteFileUpload2(_x16) {
  return _awaitRemoteFileUpload3.apply(this, arguments);
}
function _awaitRemoteFileUpload3() {
  _awaitRemoteFileUpload3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref4) {
    var _this5 = this;
    var file, queue, signal, removeEventHandlers, _this$uppy$getState2, capabilities;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          file = _ref4.file, queue = _ref4.queue, signal = _ref4.signal;
          _this$uppy$getState2 = this.uppy.getState(), capabilities = _this$uppy$getState2.capabilities;
          _context14.prev = 2;
          _context14.next = 5;
          return new Promise(function (resolve, reject) {
            var token = file.serverToken;
            var host = getSocketHost(file.remote.companionUrl);
            var socket;
            var socketAbortController;
            var activityTimeout;
            var isPaused = file.isPaused;
            var socketSend = function socketSend(action, payload) {
              if (socket == null || socket.readyState !== socket.OPEN) {
                var _socket;
                _this5.uppy.log("Cannot send \"".concat(action, "\" to socket ").concat(file.id, " because the socket state was ").concat(String((_socket = socket) == null ? void 0 : _socket.readyState)), 'warning');
                return;
              }
              socket.send(JSON.stringify({
                action: action,
                payload: payload != null ? payload : {}
              }));
            };
            function sendState() {
              if (!capabilities.resumableUploads) return;
              if (isPaused) socketSend('pause');else socketSend('resume');
            }
            var createWebsocket = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                var onFatalError, resetActivityTimeout;
                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      resetActivityTimeout = function _resetActivityTimeout() {
                        clearTimeout(activityTimeout);
                        if (isPaused) return;
                        activityTimeout = setTimeout(function () {
                          return onFatalError(new Error('Timeout waiting for message from Companion socket'));
                        }, socketActivityTimeoutMs);
                      };
                      if (socketAbortController) socketAbortController.abort();
                      socketAbortController = new AbortController();
                      onFatalError = function onFatalError(err) {
                        var _socketAbortControlle;
                        // Remove the serverToken so that a new one will be created for the retry.
                        _this5.uppy.setFileState(file.id, {
                          serverToken: null
                        });
                        (_socketAbortControlle = socketAbortController) == null || _socketAbortControlle.abort == null || _socketAbortControlle.abort();
                        reject(err);
                      }; // todo instead implement the ability for users to cancel / retry *currently uploading files* in the UI
                      _context13.prev = 4;
                      _context13.next = 7;
                      return queue.wrapPromiseFunction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
                        var reconnectWebsocket;
                        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                          while (1) switch (_context12.prev = _context12.next) {
                            case 0:
                              reconnectWebsocket = /*#__PURE__*/function () {
                                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                                    while (1) switch (_context11.prev = _context11.next) {
                                      case 0:
                                        return _context11.abrupt("return",
                                        // eslint-disable-next-line promise/param-names
                                        new Promise(function (_, rejectSocket) {
                                          socket = new WebSocket("".concat(host, "/api/").concat(token));
                                          resetActivityTimeout();
                                          socket.addEventListener('close', function () {
                                            socket = undefined;
                                            rejectSocket(new Error('Socket closed unexpectedly'));
                                          });
                                          socket.addEventListener('error', function (error) {
                                            var _socket2;
                                            _this5.uppy.log("Companion socket error ".concat(JSON.stringify(error), ", closing socket"), 'warning');
                                            (_socket2 = socket) == null || _socket2.close(); // will 'close' event to be emitted
                                          });
                                          socket.addEventListener('open', function () {
                                            sendState();
                                          });
                                          socket.addEventListener('message', function (e) {
                                            resetActivityTimeout();
                                            try {
                                              var _JSON$parse = JSON.parse(e.data),
                                                action = _JSON$parse.action,
                                                payload = _JSON$parse.payload;
                                              switch (action) {
                                                case 'progress':
                                                  {
                                                    emitSocketProgress(_this5, payload, _this5.uppy.getFile(file.id));
                                                    break;
                                                  }
                                                case 'success':
                                                  {
                                                    var _payload$response, _payload$response$sta, _payload$response2, _socketAbortControlle2;
                                                    // payload.response is sent from companion for xhr-upload (aka uploadMultipart in companion) and
                                                    // s3 multipart (aka uploadS3Multipart)
                                                    // but not for tus/transloadit (aka uploadTus)
                                                    // responseText is a string which may or may not be in JSON format
                                                    // this means that an upload destination of xhr or s3 multipart MUST respond with valid JSON
                                                    // to companion, or the JSON.parse will crash
                                                    var text = (_payload$response = payload.response) == null ? void 0 : _payload$response.responseText;
                                                    _this5.uppy.emit('upload-success', _this5.uppy.getFile(file.id), {
                                                      uploadURL: payload.url,
                                                      status: (_payload$response$sta = (_payload$response2 = payload.response) == null ? void 0 : _payload$response2.status) != null ? _payload$response$sta : 200,
                                                      body: text ? JSON.parse(text) : undefined
                                                    });
                                                    (_socketAbortControlle2 = socketAbortController) == null || _socketAbortControlle2.abort == null || _socketAbortControlle2.abort();
                                                    resolve();
                                                    break;
                                                  }
                                                case 'error':
                                                  {
                                                    var message = payload.error.message;
                                                    throw Object.assign(new Error(message), {
                                                      cause: payload.error
                                                    });
                                                  }
                                                default:
                                                  _this5.uppy.log("Companion socket unknown action ".concat(action), 'warning');
                                              }
                                            } catch (err) {
                                              onFatalError(err);
                                            }
                                          });
                                          var closeSocket = function closeSocket() {
                                            _this5.uppy.log("Closing socket ".concat(file.id), 'info');
                                            clearTimeout(activityTimeout);
                                            if (socket) socket.close();
                                            socket = undefined;
                                          };
                                          socketAbortController.signal.addEventListener('abort', function () {
                                            closeSocket();
                                          });
                                        }));
                                      case 1:
                                      case "end":
                                        return _context11.stop();
                                    }
                                  }, _callee11);
                                }));
                                return function reconnectWebsocket() {
                                  return _ref11.apply(this, arguments);
                                };
                              }();
                              _context12.next = 3;
                              return pRetry(reconnectWebsocket, {
                                retries: retryCount,
                                signal: socketAbortController.signal,
                                onFailedAttempt: function onFailedAttempt() {
                                  if (socketAbortController.signal.aborted) return; // don't log in this case
                                  _this5.uppy.log("Retrying websocket ".concat(file.id), 'info');
                                }
                              });
                            case 3:
                            case "end":
                              return _context12.stop();
                          }
                        }, _callee12);
                      })))().abortOn(socketAbortController.signal);
                    case 7:
                      _context13.next = 14;
                      break;
                    case 9:
                      _context13.prev = 9;
                      _context13.t0 = _context13["catch"](4);
                      if (!socketAbortController.signal.aborted) {
                        _context13.next = 13;
                        break;
                      }
                      return _context13.abrupt("return");
                    case 13:
                      onFatalError(_context13.t0);
                    case 14:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13, null, [[4, 9]]);
              }));
              return function createWebsocket() {
                return _ref9.apply(this, arguments);
              };
            }();
            var pause = function pause(newPausedState) {
              if (!capabilities.resumableUploads) return;
              isPaused = newPausedState;
              if (socket) sendState();
              if (newPausedState) {
                var _socketAbortControlle3;
                // Remove this file from the queue so another file can start in its place.
                (_socketAbortControlle3 = socketAbortController) == null || _socketAbortControlle3.abort == null || _socketAbortControlle3.abort(); // close socket to free up the request for other uploads
              } else {
                // Resuming an upload should be queued, else you could pause and then
                // resume a queued upload to make it skip the queue.
                createWebsocket();
              }
            };
            var onFileRemove = function onFileRemove(targetFile) {
              var _socketAbortControlle4;
              if (!capabilities.individualCancellation) return;
              if (targetFile.id !== file.id) return;
              socketSend('cancel');
              (_socketAbortControlle4 = socketAbortController) == null || _socketAbortControlle4.abort == null || _socketAbortControlle4.abort();
              _this5.uppy.log("upload ".concat(file.id, " was removed"), 'info');
              resolve();
            };
            var onCancelAll = function onCancelAll(_ref5) {
              var _socketAbortControlle5;
              var reason = _ref5.reason;
              if (reason === 'user') {
                socketSend('cancel');
              }
              (_socketAbortControlle5 = socketAbortController) == null || _socketAbortControlle5.abort == null || _socketAbortControlle5.abort();
              _this5.uppy.log("upload ".concat(file.id, " was canceled"), 'info');
              resolve();
            };
            var onFilePausedChange = function onFilePausedChange(targetFileId, newPausedState) {
              if (targetFileId !== file.id) return;
              pause(newPausedState);
            };
            var onPauseAll = function onPauseAll() {
              return pause(true);
            };
            var onResumeAll = function onResumeAll() {
              return pause(false);
            };
            _this5.uppy.on('file-removed', onFileRemove);
            _this5.uppy.on('cancel-all', onCancelAll);
            _this5.uppy.on('upload-pause', onFilePausedChange);
            _this5.uppy.on('pause-all', onPauseAll);
            _this5.uppy.on('resume-all', onResumeAll);
            removeEventHandlers = function removeEventHandlers() {
              _this5.uppy.off('file-removed', onFileRemove);
              _this5.uppy.off('cancel-all', onCancelAll);
              _this5.uppy.off('upload-pause', onFilePausedChange);
              _this5.uppy.off('pause-all', onPauseAll);
              _this5.uppy.off('resume-all', onResumeAll);
            };
            signal.addEventListener('abort', function () {
              var _socketAbortControlle6;
              (_socketAbortControlle6 = socketAbortController) == null || _socketAbortControlle6.abort();
            });
            createWebsocket();
          });
        case 5:
          return _context14.abrupt("return", _context14.sent);
        case 6:
          _context14.prev = 6;
          // @ts-expect-error used before defined
          removeEventHandlers == null || removeEventHandlers();
          return _context14.finish(6);
        case 9:
        case "end":
          return _context14.stop();
      }
    }, _callee14, this, [[2,, 6, 9]]);
  }));
  return _awaitRemoteFileUpload3.apply(this, arguments);
}
RequestClient.VERSION = packageJson.version;